export { LOGGING_SERVICE, LoggingServiceInterface, loggingServiceProvider } from 'app/core/logging/services/logging-service.interface';
export {
  WINDOW,
  WindowRef,
  BrowserWindowRef,
  windowFactory,
  browserWindowProvider,
  windowProvider,
  WINDOW_PROVIDERS } from './window-service.abstract';
